import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { PeriodLock } from './types';

export const periodLockApi = createApi({
  reducerPath: 'periodLockApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/period-lock',
  }),
  tagTypes: ['PeriodLock'],
  endpoints: builder => ({
    getPeriodLock: builder.query<PeriodLock, void>({
      query: () => ({ url: '' }),
      providesTags: ['PeriodLock'],
    }),
  }),
});

export const { useGetPeriodLockQuery } = periodLockApi;
